import { Box, Flex, Heading, Spacer, Text } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

import { colors } from 'packages/common-frontend/colors';
import { useLocalization } from 'packages/localization';

type BorrowingBaseSummarySectionHeaderProps = { headerLabel: string };
export const BorrowingBaseSummarySectionHeader = ({
  headerLabel,
}: BorrowingBaseSummarySectionHeaderProps) => {
  const { getLabel } = useLocalization();
  const localizedHeaderLabel = getLabel(headerLabel);

  return (
    <Box mb="16px">
      <Heading
        as="h3"
        fontSize="20px"
        fontWeight={600}
        pb="8px"
        borderBottom="1px"
        borderColor={colors.gray[200]}
      >
        {localizedHeaderLabel}
      </Heading>
    </Box>
  );
};

type BorrowingBaseSummarySubSectionHeaderProps = {
  headerLabel: string;
  linkAddress?: string;
  linkLabel?: string;
};
export const BorrowingBaseSummarySubSectionHeader = ({
  headerLabel,
  linkAddress,
  linkLabel,
}: BorrowingBaseSummarySubSectionHeaderProps) => {
  const { getLabel } = useLocalization();
  const localizedHeaderLabel = getLabel(headerLabel);

  return (
    <Flex mb="16px" mt="32px">
      <Heading as="h4" fontSize="18px" fontWeight={600}>
        {localizedHeaderLabel}
      </Heading>
      <Spacer />
      {linkAddress && linkLabel && (
        <Link to={linkAddress} target="_blank" rel="noopener noreferrer">
          <Text color={colors.info} _hover={{ textDecoration: 'underline' }}>
            {linkLabel} &#62;
          </Text>
        </Link>
      )}
    </Flex>
  );
};
